import React, { useState, useMemo, useEffect, useContext } from 'react';
import { Box, Tab, Tabs, Button } from '@mui/material';
import { toast } from 'react-toastify';
import RestoreIcon from '@mui/icons-material/Restore';
import Swal from 'sweetalert2';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import moment from 'moment';
import AppConst from '../../components/AppLayout/const';
import useStore from '../../states/store';
import TabPanel from '../../components/TabPanel';
import useCWPContext from './context/useCWPContext';
import { DashboardProvider } from '../Dashboard/useDashboard';
import Filter from './components/Filter';
import Table from './components/Table';
import AppointmentCalendar from '../../components/AppontmentCalendar';
import CwpDetailsModal from './components/CwpDetailsModal';
import {
  postCncCwpList,
  postCncCwpApprovalCalendar,
  postCncCwpApprovalDetail,
  postCncApprovaltUpdateStatus,
} from '../../api/cwpMaintenance';

export default function CWPApprovalCNC() {
  const { onSetTitle } = useContext(AppConst.AppContext);
  const auth = useStore((state) => state.auth);

  onSetTitle('CNC CWP Approvals');

  const defaultFilter = {
    department: { label: 'ALL', value: null },
    manager_id: { label: 'ALL', value: null },
    rep_id: { label: 'ALL', value: null },
    status: [2],
    month_year: moment().format('YYYY-MM'),
  };

  const [activeTab, setActiveTab] = useState(0);
  const [filterForm, setFilterForm] = useState(defaultFilter);
  const [rowsSelected, setRowsSelected] = useState([]);
  const [cwpData, setCwpData] = useState([]);
  const [cwpDetails, setCwpDetails] = useState({ toggle: false, data: [] });
  const [calendarData, setCalendarData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [clearFilter, setClearFilter] = useState(false);
  const [resetActive, setResetActive] = useState(false);

  const [calendarParams, setCalendarParams] = useState({
    date_month: moment().format('YYYY-MM'),
    data: [],
    date: '',
    rep_id: '',
    manager_ids: [],
    loading: false,
  });

  const handleChangeActiveTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  const searchCwp = async () => {
    // try {
    let tabstatus = null;
    if (activeTab === 0) {
      tabstatus = 2;
    } else if (activeTab === 1) {
      tabstatus = 1;
    } else {
      tabstatus = 3;
    }

    setLoading(true);
    setCalendarParams({
      ...calendarParams,
      loading: true,
    });
    const statusType = {
      department: filterForm?.department?.value,
      manager_id: auth.user_id,
      rep_id: filterForm?.rep_id?.value,
      month: [Number(moment(filterForm?.month_year).format('M'))],
      year: [Number(moment(filterForm?.month_year).format('YYYY'))],
      status: [tabstatus],
    };

    const response = await postCncCwpList(statusType);
    const calendar = await postCncCwpApprovalCalendar({ ...statusType, date_submitted: null });
    const { code, data } = response.data;

    if (code === '200') {
      setCwpData(data);
      setCalendarData(calendar?.data?.data);

      setCalendarParams({
        ...calendarParams,
        loading: false,
        date_month: moment(filterForm?.month_year).format('YYYY-MM'),
        data: calendar?.data?.data.map((row) => ({
          date: row.date,
          count: row.appointment_count.toString(),
          label: row.appointment_count > 0 ? row.appointment_count.toString() : '',
        })),
      });
    }

    setLoading(false);
    // } catch (error) {
    //   toast.error(error.message);
    // }
  };

  const clearCwp = () => {
    setFilterForm(defaultFilter);
    setClearFilter(true);
  };

  const handleViewAppointments = async (id) => {
    try {
      setCwpDetails({ toggle: false, data: [] });
      toast.loading('requesting data please wait');

      const response = await postCncCwpApprovalDetail({ appointment_id: id });

      if (response.data.code === '200') {
        const details = response?.data?.data.map((row) => ({
          ...row,
          status_id: 0,
        }));

        setCwpDetails({ toggle: true, data: details });
      }

      toast.dismiss();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleViewCalendar = async (item = null, reset = null) => {
    try {
      setCalendarParams({
        ...calendarParams,
        loading: true,
      });
      toast.loading('requesting data please wait');

      let tabstatus = null;
      if (activeTab === 0) {
        tabstatus = 2;
      } else if (activeTab === 1) {
        tabstatus = 1;
      } else {
        tabstatus = 3;
      }
      let statusType;

      if (reset) {
        setResetActive(false);
        statusType = {
          department: filterForm?.department?.value,
          manager_id: auth.user_id,
          rep_id: filterForm?.rep_id?.value,
          month: [Number(moment(filterForm?.month_year).format('M'))],
          year: [Number(moment(filterForm?.month_year).format('YYYY'))],
          status: [tabstatus],
        };
      } else {
        setResetActive(true);
        statusType = {
          department: filterForm?.department?.value,
          manager_id: auth.user_id,
          rep_id: item.rep_id,
          date_submitted: item.date_submitted,
          month: [moment(filterForm?.month_year).format('MM')],
          year: [Number(moment(filterForm?.month_year).format('YYYY'))],
          status: [tabstatus],
        };
      }
      const response = await postCncCwpApprovalCalendar(statusType);
      const { code, data } = response.data;
      if (code === '200') {
        setCalendarData(data);

        setCalendarParams({
          ...calendarParams,
          loading: false,
          date_month: moment(filterForm?.month_year).format('YYYY-MM'),
          data: data.map((row) => ({
            date: row.date,
            count: row.appointment_count.toString(),
            label: row.appointment_count > 0 ? row.appointment_count.toString() : '',
          })),
        });
      }

      toast.dismiss();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleUpdateAll = (status = null, isall = null) => {
    const statusText = status === 1 ? 'approved all appointments?' : 'reject all appointments?';
    Swal.fire({
      icon: 'warning',
      title: `Are you sure you want to ${
        isall === true ? statusText : 'submit the approvals of the selected appointments?'
      }`,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '<small style="color:#fff"> Confirm </small>',
      cancelButtonText: '<small style="color:#fff"> Cancel </small>',
    }).then((response) => {
      if (response.isConfirmed) {
        const mergeArray = [];
        const sampleArray = rowsSelected?.map((item) => item.appointment_id.split(',').concat());
        const rowIds = mergeArray
          .concat(...sampleArray)
          .map((item) => ({ appointment_id: item, approval_id: status }));

        const cwpDetailsForm =
          isall === true
            ? {
                designation: auth.designation,
                data: rowIds,
              }
            : {
                designation: auth.designation,
                data: cwpDetails?.data
                  ?.filter((item) => item.status_id !== 0)
                  .map((item) => ({
                    appointment_id: item.appointment_id,
                    approval_id: item.status_id,
                  })),
              };
        try {
          postCncApprovaltUpdateStatus(cwpDetailsForm).then((res) => {
            const { code, message } = res.data;
            if (code === '200') {
              setCwpDetails({ toggle: false, data: [] });
              toast.success(message);
              searchCwp();
            }
          });
        } catch (error) {
          toast.error(error.message);
        }
      }
    });
  };

  const handleCwpDetailStatus = (e, status, row) => {
    if (e.target.checked) {
      if (status === 1) {
        document.getElementById(`${row.id}-status-reject`).checked = false;
      } else {
        document.getElementById(`${row.id}-status-approve`).checked = false;
      }
    }

    const details = {
      ...cwpDetails,
      data: cwpDetails?.data?.map((item) =>
        item.id === row.id ? { ...item, status_id: e.target.checked ? status : 0 } : item,
      ),
    };
    setCwpDetails(details);
  };

  const handleUpdateCwpAppointment = () => {
    handleUpdateAll(null, null);
  };

  useEffect(() => {
    searchCwp();
  }, [activeTab, clearFilter]);

  return (
    <DashboardProvider>
      <useCWPContext.Provider
        value={useMemo(
          () => ({
            auth,
            activeTab,
            cwpData,
            cwpDetails,
            calendarData,
            rowsSelected,
            calendarParams,
            setCwpDetails,
            setFilterForm,
            setRowsSelected,
            setCalendarParams,
            filterForm,
            searchCwp,
            clearCwp,
            loading,
            handleUpdateAll,
            handleViewAppointments,
            handleViewCalendar,
            handleCwpDetailStatus,
            handleUpdateCwpAppointment,
          }),
          [
            filterForm,
            cwpData,
            calendarData,
            calendarParams,
            loading,
            cwpDetails.toggle,
            cwpDetails,
            rowsSelected,
          ],
        )}
      >
        <div className='body-content'>
          <Box sx={{ backgroundColor: '#fff', p: 1, boxShadow: 3 }}>
            <Filter />
          </Box>
          <Box padding={4}>
            <Box>
              <Box>
                <Grid container spacing={2}>
                  <Grid xs={12} sm={12} md={12}>
                    <Box sx={{ backgroundColor: '#fff' }} mt={4}>
                      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs
                          value={activeTab}
                          onChange={handleChangeActiveTab}
                          aria-label='basic tabs example'
                        >
                          <Tab
                            label='For Approval'
                            id='cwp-for-approval'
                            aria-controls='cwp-for-approval'
                          />
                          <Tab label='Approved' id='cwp-approved' aria-controls='cwp-approved' />
                          <Tab label='Rejected' id='cwp-rejected' aria-controls='cwp-rejected' />
                        </Tabs>
                      </Box>
                      <TabPanel value={activeTab} index={activeTab}>
                        {activeTab === 0 ? (
                          <Grid container spacing={2}>
                            <Grid md={8}>
                              <Table />
                            </Grid>

                            <Grid md={4}>
                              <Grid xs={12} sm={12} md={12} pb={1}>
                                {resetActive ? (
                                  <Button
                                    size='small'
                                    variant='contained'
                                    color='primary'
                                    sx={{ float: 'right' }}
                                    onClick={() => handleViewCalendar(null, true)}
                                    startIcon={<RestoreIcon />}
                                  >
                                    Reset
                                  </Button>
                                ) : (
                                  ''
                                )}
                              </Grid>
                              &nbsp;
                              <Grid xs={12} sm={12} md={12} pt={1}>
                                <AppointmentCalendar
                                  // initDate={moment().format('YYYY-MM-DD')}
                                  appointments={calendarParams.data}
                                  initDate={calendarParams.date_month}
                                  className='ec-container-centered'
                                  isDisableNavigation
                                  loading={calendarParams.loading}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        ) : (
                          <Table />
                        )}
                      </TabPanel>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>
        </div>
        <CwpDetailsModal />
      </useCWPContext.Provider>
    </DashboardProvider>
  );
}
